import React from "react";
import { Pagination as MuiPagination, Stack, Box } from "@mui/material";

function Pagination({ currentPage, pages, updatePageNumber }) {
  // אם יש רק עמוד אחד או אפס, אין צורך להציג דפדוף
  if (pages <= 1) return null;

  const handleChange = (event, value) => {
    updatePageNumber(value);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 4,
        mb: 2,
        width: "100%",
      }}
    >
      <Stack spacing={2}>
        <MuiPagination
          count={pages} // סך כל העמודים
          page={currentPage} // העמוד הנוכחי
          onChange={handleChange} // פונקציית השינוי
          color="primary" // ישתמש בכתום של שחל אם הגדרת אותו כ-primary בתמה
          variant="outlined" // מראה סולידי ונקי
          shape="rounded" // פינות מעוגלות עדינות שמתאימות ל-Assistant
          size="large" // נוח ללחיצה
          siblingCount={1} // כמה עמודים להציג ליד העמוד הנוכחי
          boundaryCount={1} // כמה עמודים להציג בהתחלה ובסוף
          sx={{
            "& .MuiPaginationItem-root": {
              fontFamily: "Assistant",
              fontWeight: 600,
            },
            "& .Mui-selected": {
              backgroundColor: "rgba(242, 99, 34, 0.1) !important", // רקע כתום עדין לנבחר
              borderColor: "#f26322 !important", // גבול כתום בולט
              color: "#f26322 !important",
            },
            "& .MuiPaginationItem-root:hover": {
              backgroundColor: "rgba(242, 99, 34, 0.05)",
            },
          }}
        />
      </Stack>
    </Box>
  );
}

export default Pagination;
